import { buildSort, goPromise } from "@delanobgt/admin-core/util/helpers";
import {
  ApiClientFactory,
  IMeta,
  IPagination,
  ISort,
} from "@delanobgt/admin-core/util/types";
import { CancelTokenSource } from "axios";
import _ from "lodash";

import { EBankSortField, IBank, PBank, PBankFilter } from "../entities";
import IBankRepository from "../repository";

export default class BankRepository
  implements IBankRepository<CancelTokenSource> {
  private apiClientFactory: ApiClientFactory;

  // api routes
  private BANK_ROUTE = "/admin/depatu-bank";

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClientFactory = apiClientFactory;
  }

  buildFilter = (filter: PBankFilter) => {
    return filter;
  };

  private getSignalToken(signal: CancelTokenSource) {
    return _.get(signal, "token", null);
  }

  private getError(error: any) {
    return _.get(error, "response.data.errors", "Something went wrong.");
  }

  async getBank(
    pagination: IPagination,
    filter: PBankFilter,
    sorts: ISort<EBankSortField>[],
    signal?: CancelTokenSource
  ): Promise<[IBank[], IMeta]> {
    const sort = buildSort(sorts);
    const params = _.pickBy(
      {
        ...pagination,
        ...this.buildFilter(filter),
      },
      Boolean
    );
    const [err, response] = await goPromise(
      this.apiClientFactory({ cancelToken: this.getSignalToken(signal) }).get(
        `${this.BANK_ROUTE}?sort=${sort}`,
        {
          params,
        }
      )
    );
    if (err) {
      throw this.getError(err);
    }
    const { data, meta } = response.data;
    return [data, meta];
  }

  async getBankById(id: number): Promise<IBank> {
    const [err, response] = await goPromise(
      this.apiClientFactory().get(`${this.BANK_ROUTE}/${id}`)
    );
    if (err) {
      throw this.getError(err);
    }
    return response.data;
  }

  async createBank(bank: PBank): Promise<void> {
    const [err] = await goPromise(
      this.apiClientFactory().post(this.BANK_ROUTE, bank)
    );
    if (err) {
      throw this.getError(err);
    }
  }

  async updateBank(id: number, bank: PBank): Promise<void> {
    const [err] = await goPromise(
      this.apiClientFactory().patch(`${this.BANK_ROUTE}/${id}`, bank)
    );
    if (err) {
      throw this.getError(err);
    }
  }
}
